import { HourglassDisabled, Close, Check } from '@mui/icons-material';
import { wellzTheme } from 'theme/index';

import { InviteStatus } from 'services/index';

export const statusActions: Array<{ key: string; param: InviteStatus | null }> =
  [
    { key: 'CPPLATFORM.CPINVITEMANAGEMENT.FILTERALLTHESTATUS', param: null },
    {
      key: 'CPPLATFORM.CPINVITEMANAGEMENT.FILTERACTIVESTATUS',
      param: 'pending',
    },
    {
      key: 'CPPLATFORM.CPINVITEMANAGEMENT.FILTEREXPIREDSTATUS',
      param: 'expired',
    },
    {
      key: 'CPPLATFORM.CPINVITEMANAGEMENT.FILTERREFUSEDSTATUS',
      param: 'rejected',
    },
    {
      key: 'CPPLATFORM.CPINVITEMANAGEMENT.FILTERACCEPTEDSTATUS',
      param: 'accepted',
    },
  ];

export const keyByStatus = {
  pending: {
    key: 'CPPLATFORM.CPINVITEMANAGEMENT.VALIDATELINK',
    color: wellzTheme.colors.text.disabled,
    icon: null,
  },
  expired: {
    key: 'CPPLATFORM.CPINVITEMANAGEMENT.EXPIREDSTATUS',
    color: wellzTheme.colors.deepRed,
    icon: (
      <HourglassDisabled
        sx={{ fontSize: 16, fill: wellzTheme.colors.deepRed }}
      />
    ),
  },
  rejected: {
    key: 'CPPLATFORM.CPINVITEMANAGEMENT.REFUSEDSTATUS',
    color: wellzTheme.colors.deepRed,
    icon: <Close sx={{ fontSize: 16, fill: wellzTheme.colors.deepRed }} />,
  },
  accepted: {
    key: 'CPPLATFORM.CPINVITEMANAGEMENT.ACCEPTEDSTATUS',
    color: wellzTheme.colors.primary,
    icon: <Check sx={{ fontSize: 16, fill: wellzTheme.colors.primary }} />,
  },
};
